( function () {
    'use strict';
    e.ecom.quick = {};
    e.ecom.quick.init = function () {
        e.ecom.quick.jOrderForm = jQuery( '.js-e-quick-order-form' );
        if ( e.ecom.quick.jOrderForm.length === 1 ) {
            e.ecom.quick.arrProducts = [];
            e.ecom.quick.arrProductMap = {};
            e.ecom.quick.QuickOrderCount = 0;
            e.ecom.quick.handlebarsTemplate = null;
            if ( typeof Handlebars !== 'object' ) {
                //lav med ajax function med cache
                jQuery.getScript( '//cdnjs.cloudflare.com/ajax/libs/handlebars.js/1.0.0/handlebars.min.js', function () {
                    e.ecom.quick.handlebarsTemplate = Handlebars.compile( jQuery( '#js-e-quick-order-handlebars-template' ).html() );
                    Handlebars.registerHelper( 'inStock', function ( stock, options ) {
                        if ( parseInt( stock ) > 0 ) {
                            return options.fn( this );
                        }
                        else {
                            return options.inverse( this );
                        }
                    } );
                } );
            }
            else {
                e.ecom.quick.handlebarsTemplate = Handlebars.compile( jQuery( '#js-e-quick-order-handlebars-template' ).html() );
                Handlebars.registerHelper( 'inStock', function ( stock, options ) {
                    if ( parseInt( stock ) > 0 ) {
                        return options.fn( this );
                    }
                    else {
                        return options.inverse( this );
                    }
                } );
            }
            e.ecom.quick.validate();
            e.ecom.quick.inputTypeahead();
            e.ecom.quick.unsavedData();
        }
    };
    e.ecom.quick.inputTypeahead = function () {
        e.ecom.quick.jOrderForm.find( '#js-e-quick-order-typeahead-input' ).on( 'keydown keypress keyup', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                if ( this.value === '' ) {
                    e.ecom.quick.jOrderForm.find( 'button[type="submit"]' ).focus();
                }
                else if ( e.ecom.quick.arrProducts.length === 0 ) {
                    e.ecom.quick.jOrderForm.find( '.js-e-msg-no-result' ).show();
                }
            }
        } ).on( 'focus', function () {
            var jScrollTarget = e.ecom.quick.jOrderForm;
            if ( e.ecom.quick.jOrderForm.find( 'table tbody tr' ).length > 0 ) {
                jScrollTarget = e.ecom.quick.jOrderForm.find( 'table tbody tr' ).last();
            }
            e.util.scroll.toElement( jScrollTarget, 0, false, true );
        } ).typeahead( {
            menu: '<ul class="typeahead nav dropdown-menu js-e-typeahead-dropdown"></ul>',
            source: function ( query, process ) {
                return jQuery.ajax( {
                    url: '/Admin/Public/eCom/InstantSearch.ashx',
                    data: {
                        ID: e.ecom.quick.jOrderForm.find( '.js-e-quick-order-page-id' ).text(),
                        PID: e.ecom.quick.jOrderForm.find( '.js-e-quick-order-paragraph-id' ).text(),
                        o: 'json',
                        InstantSearchType: 'Search',
                        Caller: 'eComQuery',
                        eComQuery: query
                    },
                    dataType: 'json',
                } ).success( function ( data ) {
                    e.ecom.quick.arrProducts = [];
                    e.ecom.quick.arrProductMap = {};
                    jQuery.each( data.Data, function ( index, Product ) {
                        if ( Product.__type === 'ProductIndexEntry:#Dynamicweb.eCommerce.Searching.Index' && Product.IsActive === true && ( ( Product.IsVariant === false && Product.VariantCount === 0 ) || Product.IsVariant === true ) ) {
                            var productItem = Product.Number + ': ' + Product.Name;
                            e.ecom.quick.arrProductMap[ productItem ] = Product;
                            e.ecom.quick.arrProducts.push( productItem );
                        }
                    } );
                    if ( e.ecom.quick.arrProducts.length > 0 ) {
                        e.ecom.quick.jOrderForm.find( '.js-e-msg-no-result' ).hide();
                    }
                    return process( e.ecom.quick.arrProducts );
                } );
            },
            sorter: function ( items ) {
                var beginsWith = [],
                    wordBeginsWith = [],
                    caseSensitive = [],
                    caseInsensitive = [],
                    metaContains = [],
                    item;
                while ( item = items.shift() ) {
                    var theQuery = this.query;
                    if ( item.toLowerCase().indexOf( theQuery.toLowerCase() ) === 0 ) {
                        beginsWith.push( item );
                    }
                    else if ( jQuery.grep( item.toLowerCase().split( ' ' ), function ( n ) {
                            return n.indexOf( theQuery.toLowerCase() ) === 0;
                        } ).length > 0 ) {
                        wordBeginsWith.push( item );
                    }
                    else if ( ~item.indexOf( theQuery ) ) {
                        caseSensitive.push( item );
                    }
                    else if ( ~item.toLowerCase().indexOf( theQuery.toLowerCase() ) ) {
                        caseInsensitive.push( item );
                    }
                    else {
                        metaContains.push( item );
                    }
                }
                return beginsWith.concat( wordBeginsWith, caseSensitive, caseInsensitive, metaContains );
            },
            matcher: function ( item ) {
                return item;
            },
            updater: function ( item ) {
                if ( e.ecom.quick.QuickOrderCount === 0 ) {
                    e.ecom.quick.jOrderForm.find( 'thead' ).after( '<tbody />' );
                }
                if ( e.ecom.quick.jOrderForm.find( 'table tbody tr' ).length >= 0 ) {
                    e.ecom.quick.jOrderForm.find( 'button[type="submit"]' ).prop( 'disabled', false );
                }
                e.ecom.quick.QuickOrderCount++;
                e.ecom.quick.arrProductMap[ item ].ePriceWithVAT_Formated = e.util.formatNumber( e.ecom.quick.arrProductMap[ item ].PriceWithVAT );
                //template flyttes ud af scope så dan kan genbruges
                var strHandlebarsHTML = e.ecom.quick.handlebarsTemplate( e.ecom.quick.arrProductMap[ item ] );
                e.ecom.quick.jOrderForm.find( 'tbody' ).append( strHandlebarsHTML.replace( /_QuickOrderCount_/g, e.ecom.quick.QuickOrderCount ) );
                e.ecom.quick.updateUnitPrice( e.ecom.quick.jOrderForm.find( 'tbody tr' ).last() );
                //console.log( scroll, 'updater' );
                e.util.scroll.toElement( e.ecom.quick.jOrderForm.find( '#js-e-quick-order-typeahead-input' ), parseInt( e.ecom.quick.jOrderForm.css( 'line-height' ), 10 ) * -2 );
                e.ecom.quick.jOrderForm.find( '.js-e-quick-order-row-quantity' ).last().focus().select();
                return '';
            }
        } ).focus();
        e.ecom.quick.jOrderForm.find( '#js-e-quick-order-typeahead-submit' ).on( 'click', function ( event ) {
            event.preventDefault();
            e.ecom.quick.jQuickOrder.find( '.js-e-typeahead-dropdown' ).filter( ':visible' ).find( '.active' ).click();
        } );
        e.ecom.quick.jOrderForm.on( 'change keyup', '.js-e-quick-order-row-quantity', function () {
            e.ecom.quick.updateTotalPrice( jQuery( this ).closest( 'tr' ) );
        } ).on( 'keydown keypress keyup', '.js-e-quick-order-row-quantity', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                if ( event.type === 'keyup' ) {
                    e.ecom.quick.jOrderForm.find( '#js-e-quick-order-typeahead-input' ).focus();
                }
            }
        } );
        e.ecom.quick.jOrderForm.on( 'click', '.js-e-quick-order-delete-row', function ( event ) {
            event.preventDefault();
            jQuery( this ).closest( 'tr' ).remove();
            e.ecom.quick.jOrderForm.find( '#js-e-quick-order-typeahead-input' ).focus();
            if ( e.ecom.quick.jOrderForm.find( 'table tbody tr' ).length <= 0 ) {
                e.ecom.quick.jOrderForm.find( 'button[type="submit"]' ).prop( 'disabled', true );
            }
        } );
    };
    e.ecom.quick.updateUnitPrice = function ( jTableRow ) {
        jQuery.ajax( {
            url: jTableRow.find( '[name="ProductURL' + e.ecom.quick.QuickOrderCount + '"]' ).val(),
            type: 'get',
            dataType: 'html',
        } ).done( function ( responseText ) {
            var jUnitprice = jTableRow.find( '.js-e-quick-order-row-unitprice' );
            jUnitprice.html( jQuery( '<div>' ).append( jQuery.parseHTML( responseText ) ).find( '.js-e-price' ).html() );
            jTableRow.find( '.e-loading-spinner' ).fadeOut( 'fast', function () {
                jUnitprice.fadeIn( 'fast' );
                e.ecom.quick.updateTotalPrice( jTableRow );
            } );
        } );
    };
    e.ecom.quick.updateTotalPrice = function ( jTableRow ) {
        var jTotalPrice = jTableRow.find( '.js-e-quick-order-row-totalprice' ),
            quantity = jTableRow.find( '.js-e-quick-order-row-quantity' ).val(),
            unitprice = jTableRow.find( '.js-e-quick-order-row-unitprice' ).html().replace( e.config.regExpIntergerSeparator, '' ).replace( e.config.regExpDecimalSeparator, '.' );
        if ( isNaN( parseFloat( unitprice, 10 ) ) || isNaN( parseInt( quantity, 10 ) ) || parseInt( quantity, 10 ) === 0 ) {
            jTotalPrice.html( '0' );
        }
        else {
            jTotalPrice.html( e.util.formatNumber( parseInt( quantity, 10 ) * parseFloat( unitprice ) ) );
        }
    };
    e.ecom.quick.validate = function () {
        jQuery( '.js-e-quick-order-form' ).validate( {
            errorClass: 'text-error',
            errorElement: 'code',
            errorPlacement: function () {},
            highlight: function ( element, errorClass ) {
                jQuery( element ).popover( {
                    selector: element,
                    content: jQuery.validator.messages.digits
                } ).popover( 'show' ).siblings( '.popover' ).addClass( errorClass );
            },
            unhighlight: function ( element ) {
                jQuery( element ).popover( 'hide' );
            },
            submitHandler: function ( form ) {
                e.constant.jWindow.off( 'beforeunload' );
                form.submit();
            }
        } );
    };
    e.ecom.quick.unsavedData = function () {
        e.constant.jWindow.on( 'beforeunload', function () {
            var errorMessage = jQuery( '#quick-order-modal' ).find( '.js-quick-modal-message' ).text().trim();
            if ( e.ecom.quick.jOrderForm.find( 'table tbody tr' ).length > 0 ) {
                return errorMessage;
            }
        } );
        jQuery( 'body' ).on( 'click', 'a[href!="javascript:void(0);"]', function ( event ) {
            if ( e.ecom.quick.jOrderForm.find( 'table tbody tr' ).length > 0 ) {
                event.preventDefault();
                e.ecom.quick.unsavedData.modal( this.href );
            }
        } );
    };
    e.ecom.quick.unsavedData.modal = function ( href ) {
        jQuery( '#quick-order-modal' ).modal();
        jQuery( '.js-quick-modal-leave' ).on( 'click', function () {
            e.constant.jWindow.off( 'beforeunload' );
            window.location.href = href;
        } );
    };
}() );
